<template>
  <v-sheet elevation="2" class="px-12 py-8 rounded white">
    <Form
      v-if="isFormVisible"
      :webhook="selectedWebhook"
      :organizationId="organizationId"
      @saved="showList"
      @deleted="showList"
      @cancel="showList"
    />
    <List
      v-else
      :organizationId="organizationId"
      @addWebhook="addWebhook"
      @editWebhook="editWebhook"
    />
  </v-sheet>
</template>

<script>
import List from './List'
import Form from './Form'

export default {
  name: 'WebhooksContainer',

  components: {
    List,
    Form,
  },

  props: {
    organizationId: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      isFormVisible: false,
      selectedWebhook: null,
    }
  },

  methods: {
    addWebhook() {
      this.isFormVisible = true
      this.selectedWebhook = {
        enabled: true,
        events: ['all'],
      }
    },

    editWebhook(webhook) {
      this.isFormVisible = true
      this.selectedWebhook = webhook
    },

    showList() {
      this.isFormVisible = false
      this.selectedWebhook = null
    },
  },
}
</script>
